import React, { Component } from "react";
import SectionWithBorder from "../../../components/UIComponent/SectionBorder";
import ChapterSection from "../../../components/membership/membershipPricing/ChapterSection";
import Row3Input from "../../../components/membership/membershipPricing/Row3Input";
import MembershipPricingServices from "../../../services/axiosServices/apiServices/MembershipPricingServices";
import { NavLink } from "react-router-dom";
import TextInput from "../../../components/UIComponent/TextInput";
import SwalServices from "../../../services/swalServices/SwalServices";

import {
  isValidForm,
  validate,
} from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";

export default class MembershipPricing extends Component {
  constructor(props) {
    super(props);
    this.membershipPricingServices = new MembershipPricingServices();
    this.swalServices = new SwalServices();

    this.state = {
      // membershipPricing: {
      //   membershipPricingId: 0,
      //   baseOrdinaryFee: 0,
      //   baseAssociateFee: 0,
      //   annualOrdinaryFee1M: 0,
      //   annualOrdinaryFee10M: 0,
      //   annualOrdinaryFee30M: 0,
      //   annualOrdinaryFee50M: 0,
      //   annualOrdinaryFeeMax: 0,
      //   annualAssociateFee1M: 0,
      //   annualAssociateFee10M: 0,
      //   annualAssociateFee30M: 0,
      //   annualAssociateFee50M: 0,
      //   annualAssociateFeeMax: 0,
      //   annualFreeChapter: 0,
      //   annualAdditionalChapterPrice: 0,
      //   startUpEntranceFee: 0,
      //   startUp1stYearFee: 0,
      //   startUp2ndYearFee: 0,
      //   startUp3rdYearFee: 0,
      //   startUp4thYearFee: 0,
      //   startUp5thYearFee: 0,
      //   startUpFreeChapter: 0,
      //   startUpAdditionalChapterPrice: 0,
      // },
      membershipPricing: {
        membershipBasePriceId: 0,
        membershipTypeId: 0,
        ordinaryEntranceFee: 0,
        ordinaryAbove10B: 0,
        ordinaryAbove5B: 0,
        ordinaryAbove1B: 0,
        ordinaryAbove500M: 0,
        ordinaryBelow500M: 0,
        associateEntranceFee: 0,
        associateSubscriptionFee: 0,
        ordinarySubscriptionFee: 0,
        membershipPricingData: [],
      },
      membershipProRatedPricing: [],
      // membershipProRatedPricing: {
      //   membershipTypeId: 0,
      //   membershipMonth: 0,
      //   entranceFee: 0,
      //   subscriptionFee: 0,
      // },
      validationRule: {
        // annualFreeChapter: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUpFreeChapter: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        ordinaryEntranceFee: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        // qualifyingEntranceFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        associateEntranceFee: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinarySubscriptionFee: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        // qualifyingSubscriptionFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        associateSubscriptionFee: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinaryAbove10B: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinaryAbove5B: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinaryAbove1B: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinaryAbove500M: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinaryBelow500M: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        ordinaryEntranceFee: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        annualAssociateFee10M: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        annualAssociateFee30M: [
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "only numeric values"
            ),
          },
        ],
        // annualAssociateFee50M: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // annualAssociateFeeMax: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // annualAdditionalChapterPrice: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUpEntranceFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUp1stYearFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUp2ndYearFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUp3rdYearFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUp4thYearFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUp5thYearFee: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
        // startUpAdditionalChapterPrice: [
        //   {
        //     type: "number",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "only numeric values"
        //     ),
        //   },
        // ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      isLoading: false
    };
  }
  handleChange(event) {
    const value = event.target.value;
    var num = parseFloat(value).toFixed(0);
    const name = event.target.name;
    let detail = this.state.membershipPricing;
    detail[name] = num;
    this.setState({ membershipPricing: { ...detail } });
  }

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.membershipPricing,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.membershipPricing,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  addMembershipPricing = () => {
    let isValid = this.isValidateAllFields();
    if (isValid) {
      this.membershipPricingServices
        .addEditMembershipPricing(this.state.membershipPricing)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            this.swalServices.Success(
              "Membership pricing updated successfully."
            );
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };

  getMembershipPricing = () => {
    this.membershipPricingServices.getMembershipPricing().then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        let details = response.responseItem.responseContent;
        let membershipPricing = this.state.membershipPricing;
        membershipPricing.membershipPricingData = details;
        membershipPricing.ordinaryEntranceFee = details[0].entranceFee;
        membershipPricing.ordinaryAbove10B = details[1].subscriptionFee;
        membershipPricing.ordinaryAbove5B = details[2].subscriptionFee;
        membershipPricing.ordinaryAbove1B = details[3].subscriptionFee;
        membershipPricing.ordinaryAbove500M = details[4].subscriptionFee;
        membershipPricing.ordinaryBelow500M = details[5].subscriptionFee;
        membershipPricing.associateEntranceFee = details[6].entranceFee;
        membershipPricing.associateSubscriptionFee = details[6].subscriptionFee;
        this.setState({
          membershipPricing: membershipPricing,
        });
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  updateMembershipPricingData = () => {
    let audit = getAuditContext();

    let request = {
      ...this.state.membershipPricing,
      updatedBy: audit.adminUserId,
      updatedAppId: audit.appId
    };

    request.membershipPricingData[0].entranceFee = request.ordinaryEntranceFee;
    request.membershipPricingData[1].subscriptionFee = request.ordinaryAbove10B;
    request.membershipPricingData[2].subscriptionFee = request.ordinaryAbove5B;
    request.membershipPricingData[3].subscriptionFee = request.ordinaryAbove1B;
    request.membershipPricingData[4].subscriptionFee = request.ordinaryAbove500M;
    request.membershipPricingData[5].subscriptionFee = request.ordinaryBelow500M;
    request.membershipPricingData[6].entranceFee = request.associateEntranceFee;
    request.membershipPricingData[6].subscriptionFee = request.associateSubscriptionFee;
    this.membershipPricingServices.updateMembershipPricingData(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        let details = response.responseItem.responseContent;
        this.setState({
          membershipPricing: details,
        },
          () => {
            this.swalServices.Success("Membership pricing updated successfully!");
            this.getMembershipPricing();
          }
        );


      }
      else {
        this.swalServices.Error(response.message);
      }
    })
  }





  getAllMembershipProRatedPricing = () => {
    this.membershipPricingServices.getAllMembershipProRatedPricing().then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        this.setState({ membershipProRatedPricing: response.responseItem.responseContent });
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  componentDidMount() {
    let audit = getAuditContext();
    this.getMembershipPricing();
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  }

  getMonthName = (monthNumber) => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[monthNumber - 1];
  };

  filterByMembershipType = (typeId) => {
    return this.state.membershipProRatedPricing.filter(item => item.membershipTypeId === typeId);
  };

  renderRows = () => {
    const ordinaryData = this.filterByMembershipType(1);
    const qualifyingData = this.filterByMembershipType(2);
    const associateData = this.filterByMembershipType(3);

    return ordinaryData.map((month, index) => (
      <tr key={index} className="border-b border-gray-200">
        <td className="text-sm text-gray-600 px-4 py-2 text-center border-r border-gray-200">
          {this.getMonthName(month.membershipMonth)}
        </td>
        <td className="text-sm text-gray-600 px-2 py-2 text-center border-r border-gray-200">{`$${ordinaryData[index].entranceFee}`}</td>
        <td className="text-sm text-gray-600 px-2 py-2 text-center border-r border-gray-200">{`$${ordinaryData[index].subscriptionFee}`}</td>
        <td className="text-sm text-gray-600 px-2 py-2 text-center border-r border-gray-200">{`$${qualifyingData[index].entranceFee}`}</td>
        <td className="text-sm text-gray-600 px-2 py-2 text-center border-r border-gray-200">{`$${qualifyingData[index].subscriptionFee}`}</td>
        <td className="text-sm text-gray-600 px-2 py-2 text-center border-r border-gray-200">{`$${associateData[index].entranceFee}`}</td>
        <td className="text-sm text-gray-600 px-2 py-2 text-center border-r border-gray-200">{`$${associateData[index].subscriptionFee}`}</td>
      </tr>
    ));
  };

  render() {
    return (
      <>
        <div className="main-body-section">
          <div className="bg-white">
            <div className="heading-part pl-7 py-4 border-b">
              <div className="flex items-center justify-between">
                <h4 className="small-title font-bold theme-color">
                  Base Pricing Table
                </h4>
              </div>
            </div>
            <div className="custom-card shadow-lg mb-10">
              <div className="">
                <SectionWithBorder
                  column1="Fees"
                  column2="Ordinary Membership (OM)"
                  column3="Associate Member (AM)"
                >
                  <div className="sign-icon-input px-7">
                    <div className="pr-24">
                      <Row3Input
                        className="text-base text-[#757575]"
                        caption="Entrance Fee (One-Time)"
                        col1value={this.state.membershipPricing.ordinaryEntranceFee}
                        col2value={
                          this.state.membershipPricing.associateEntranceFee
                        }
                        col1FieldName="ordinaryEntranceFee"
                        col2FieldName="associateEntranceFee"
                        col1InputType="Money"
                        col2InputType="Money"
                        handleChange={this.handleChange.bind(this)}
                        validateField={this.validateField.bind(this)}
                        validState={this.state.validState}
                        error1={this.state.validState.error.ordinaryEntranceFee}
                        error2={this.state.validState.error.associateEntranceFee}
                      />
                    </div>
                  </div>
                </SectionWithBorder>

                <div className="annual-member-fee">
                  <SectionWithBorder
                    column1="Annual Membership Fee (Subscription Fee)"
                    column2=""
                    column3=""
                  >
                    <div className="px-7">
                      <div className="pr-24">

                        <Row3Input
                          className="text-base text-[#757575]"
                          caption=""
                          col2value={
                            this.state.membershipPricing.associateSubscriptionFee
                          }
                          col2FieldName="associateSubscriptionFee"
                          col1InputType="Hidden"
                          col2InputType="Money"
                          handleChange={this.handleChange.bind(this)}
                          validateField={this.validateField.bind(this)}
                          validState={this.state.validState}
                          error2={
                            this.state.validState.error.associateSubscriptionFee
                          }
                        />

                      </div>
                    </div>
                    <h2 className="text-base ml-12 mt-10 text-zinc-500">
                      <b>Group Assets</b>
                    </h2>
                    <div className="px-7">
                      <div className="pr-24">
                        <Row3Input
                          className="text-base text-[#757575]"
                          caption="Above $10 billion"
                          col1value={
                            this.state.membershipPricing.ordinaryAbove10B
                          }
                          // col2value={
                          //   this.state.membershipPricing.ordinaryAbove10B
                          // }
                          col1FieldName="ordinaryAbove10B"
                          // col2FieldName="ordinaryEntranceFee"
                          col1InputType="Money"
                          // col2InputType="Money"
                          handleChange={this.handleChange.bind(this)}
                          validateField={this.validateField.bind(this)}
                          validState={this.state.validState}
                          error1={
                            this.state.validState.error.ordinaryAbove10B
                          }
                        // error2={
                        //   this.state.validState.error.ordinaryEntranceFee
                        // }
                        />

                        <Row3Input
                          className="text-base text-[#757575]"
                          caption="Above $5 billion"
                          col1value={
                            this.state.membershipPricing.ordinaryAbove5B
                          }
                          // col2value={
                          //   this.state.membershipPricing.annualAssociateFee10M
                          // }
                          col1FieldName="ordinaryAbove5B"
                          // col2FieldName="annualAssociateFee10M"
                          col1InputType="Money"
                          // col2InputType="Money"
                          handleChange={this.handleChange.bind(this)}
                          validateField={this.validateField.bind(this)}
                          validState={this.state.validState}
                          error1={
                            this.state.validState.error.ordinaryAbove5B
                          }
                        // error2={
                        //   this.state.validState.error.annualAssociateFee10M
                        // }
                        />

                        <Row3Input
                          className="text-base text-[#757575]"
                          caption="Above $1 billion"
                          col1value={
                            this.state.membershipPricing.ordinaryAbove1B
                          }
                          // col2value={
                          //   this.state.membershipPricing.annualAssociateFee30M
                          // }
                          col1FieldName="ordinaryAbove1B"
                          // col2FieldName="annualAssociateFee30M"
                          col1InputType="Money"
                          // col2InputType="Money"
                          handleChange={this.handleChange.bind(this)}
                          validateField={this.validateField.bind(this)}
                          validState={this.state.validState}
                          error1={
                            this.state.validState.error.ordinaryAbove1B
                          }
                        // error2={
                        //   this.state.validState.error.annualAssociateFee30M
                        // }
                        />

                        <Row3Input
                          className="text-base text-[#757575]"
                          caption="Above $500 million"
                          col1value={
                            this.state.membershipPricing.ordinaryAbove500M
                          }
                          // col2value={
                          //   this.state.membershipPricing.annualAssociateFee50M
                          // }
                          col1FieldName="ordinaryAbove500M"
                          // col2FieldName="annualAssociateFee50M"
                          col1InputType="Money"
                          // col2InputType="Money"
                          handleChange={this.handleChange.bind(this)}
                          validateField={this.validateField.bind(this)}
                          validState={this.state.validState}
                          error1={
                            this.state.validState.error.ordinaryAbove500M
                          }
                        // error2={
                        //   this.state.validState.error.annualAssociateFee50M
                        // }
                        />

                        <Row3Input
                          className="text-base text-[#757575]"
                          caption="$500 million and below"
                          col1value={
                            this.state.membershipPricing.ordinaryBelow500M
                          }
                          // col2value={
                          //   this.state.membershipPricing.annualAssociateFeeMax
                          // }
                          col1FieldName="ordinaryBelow500M"
                          // col2FieldName="annualAssociateFeeMax"
                          col1InputType="Money"
                          // col2InputType="Money"
                          handleChange={this.handleChange.bind(this)}
                          validateField={this.validateField.bind(this)}
                          validState={this.state.validState}
                          error1={
                            this.state.validState.error.ordinaryBelow500M
                          }
                        // error2={
                        //   this.state.validState.error.annualAssociateFeeMax
                        // }
                        />
                      </div>
                    </div>
                  </SectionWithBorder>
                </div>
                <div className="xl:col-span-2 md:col-span-6 col-span-12 mt-3">
                  <div className="col-span-12 flex justify-end">
                    {this.state.isLoading ? (
                      <div className="relative w-[150px]">
                        <button className={"text-xl font-bold text-white btn-blue-border w-full bg-blue-500 p-2 mx-4 rounded-md hover:bg-blue-600 focus:outline-none"}>
                          <span className="absolute left-[15px] top-1/2 transform -translate-y-1/2">
                            <i className="fa fa-spinner fa-spin text-white text-[17px]"></i>
                          </span>
                          <span className="ml-8">
                            Loading
                          </span>
                        </button>
                      </div>
                    ) : (
                      <button
                        className={`text-xl font-bold text-white btn-blue-border w-[150px] bg-blue-500 p-2 mx-4 rounded-md hover:bg-blue-600 focus:outline-none`}
                        onClick={() => this.updateMembershipPricingData()}
                      >
                        Update
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}
